import React from "react";
import "./ExamPrep.css";

const C1ExamPrep = () => {
  return (
    <div className="a1ExamPrepCover">
      <h3>
        Goethe <span>C1 Exam</span> Preparation
      </h3>
      <p>C1 is the advanced level in German. To prepare for the C1 level: </p>
      <ul>
        <li>
          Learn advanced terms in different subjects. Enhance your understanding
          of complex grammar structures and sentence formations.
        </li>
        <li>
          Practice reading challenging texts, such as academic papers,
          literature, or opinion pieces.
        </li>
        <li>Compose well-structured essays, reports, or critical analyses.</li>
        <li>
          Engage with complex audio materials, such as lectures, presentations,
          or debates, and further refine your fluency and ability to articulate
          complex ideas.
        </li>
      </ul>
    </div>
  );
};

export default C1ExamPrep;
